import { useEffect } from "react"
import { zeroAddress } from "viem"
import { useAccount } from "wagmi"
import { updateExternalPrices } from "@lib/cart/getExternalPrices"
import { useEthersProvider } from "@lib/ethers"
import { updateAllowedItems } from "@lib/cart/getAllowedItems"
import { useSliceContext } from "@components/SliceProvider"
import ListCard from "../ListCard"
import { useSIWEAccount } from "react-walletkit"

const CartList = () => {
  const { appChainId, cart, updateCart, setIsUpdatingCart } = useSliceContext()
  const { address, isReconnecting } = useAccount()
  const provider = useEthersProvider()
  const { address: signerWallet, isLoading: isLoadingSmartWallet } =
    useSIWEAccount()
  const buyer = signerWallet || address

  async function updateDynamicElements() {
    setIsUpdatingCart(true)
    // TODO: do them in parallel

    let updatedCart = [...cart]

    // Update isAllowed
    const checkAllowedItems = cart.filter(
      (el) =>
        el.extCheckSig != "0x" &&
        el.extCheckSig != "0x00000000" &&
        el.extCheckAddress != zeroAddress
    )

    if (checkAllowedItems.length != 0) {
      updatedCart = await updateAllowedItems({
        cart,
        checkAllowedItems,
        buyer,
        provider
      })

      updateCart(updatedCart)
    }

    // Update prices
    const dynamicItems = cart.filter((el) => el.externalAddress != zeroAddress)

    if (dynamicItems.length != 0) {
      updatedCart = await updateExternalPrices({
        cart,
        dynamicItems,
        buyer,
        chainId: appChainId
      })
    }

    updateCart(updatedCart)

    setIsUpdatingCart(false)
  }

  useEffect(() => {
    if (!isReconnecting && !isLoadingSmartWallet) {
      updateDynamicElements()
    }
  }, [buyer, isReconnecting, isLoadingSmartWallet])

  return (
    <div className="sl-space-y-8">
      {cart?.map((product, key) => {
        return <ListCard product={product} key={key} />
      })}
    </div>
  )
}

export default CartList
